const RESOURCES = {
    BENEFITS: {
        RESOURCE_ID: 'resourcesBenefits',
    },
    CHARTS: {
        RESOURCE_ID: 'resourcesCharts',
    },
    GUIDES: {
        RESOURCE_ID: 'resourcesGuides',
    },
    DISCRIMINATION_AND_EQUAL_EMPLOYMENT: {
        RESOURCE_ID: 'resourcesDiscriminationEqualEmployment',
    },
    HIRING: {
        RESOURCE_ID: 'resourcesHiring',
    },
    HR_CHECKLISTS: {
        RESOURCE_ID: 'resourcesChecklists',
    },
    LANDING_PAGE: {
        RESOURCE_ID: 'resources',
    },
    LEAVES_AND_TIME_OFF: {
        RESOURCE_ID: 'resourcesLeavesAndTimeOff',
    },
    MANAGING_EMPLOYEES: {
        RESOURCE_ID: 'resourcesManagingEmployees',
    },
    SAFETY_AND_HEALTH: {
        RESOURCE_ID: 'resourcesSafetyAndHealth',
    },
    TERMINATION: {
        RESOURCE_ID: 'resourcesTermination',
    },
    Q_AND_A: {
        RESOURCE_ID: 'resourcesQa',
    },
    VIDEOS: {
        RESOURCE_ID: 'resourcesVideos',
    },
    WAGE_AND_HOUR: {
        RESOURCE_ID: 'resourcesWageHour',
    },
    WEBINARS: {
        RESOURCE_ID: 'resourcesWebinars',
    },
};

export default RESOURCES;
